import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import PendoCollapseItem from './pendo-collapse-item.vue.js';
import { getScrollParent } from '../../utils/dom.js';
import { PendoAnalytics } from '../../directives/analytics/pendo-analytics.js';

Vue.use(VueScrollTo);
var script = {
  name: 'PendoCollapse',
  components: {
    PendoCollapseItem
  },
  directives: {
    PendoAnalytics
  },
  provide() {
    return {
      $collapse: this
    };
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    theme: {
      type: String,
      default: 'app'
    },
    accordion: {
      type: Boolean,
      default: false
    },
    panels: {
      type: [Array, Object],
      default: () => []
    },
    panelHeaderProps: {
      type: Object,
      default: () => ({})
    },
    panelScrollConfig: {
      type: [Boolean, Object],
      default: false
    },
    forceAlwaysOpen: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      expandedPanels: [...new Set([].concat(...[this.forceAlwaysOpen, this.value]))]
    };
  },
  computed: {
    model: {
      get() {
        return this.expandedPanels;
      },
      set(val) {
        this.expandedPanels = [...new Set([].concat(...[this.forceAlwaysOpen, val]))];
        this.$emit('change', this.expandedPanels);
      }
    },
    formattedPanels() {
      return this.panels.map(panel => _objectSpread2(_objectSpread2({}, panel), {}, {
        prefixIcon: _objectSpread2(_objectSpread2({}, this.panelHeaderProps.prefixIcon), panel.prefixIcon),
        suffixIcon: _objectSpread2(_objectSpread2(_objectSpread2({}, panel.suffixIcon !== false && {
          type: 'chevron-down',
          size: '14px',
          stroke: '#6a6c75'
        }), this.panelHeaderProps.suffixIcon), panel.suffixIcon)
      }));
    }
  },
  watch: {
    value(value) {
      this.expandedPanels = [...new Set([].concat(...[this.forceAlwaysOpen, value]))];
    }
  },
  methods: {
    scrollPanelIntoView(name) {
      if (!this.panelScrollConfig) {
        return;
      }
      const element = `#${name}`;
      const container = this.panelScrollConfig.container || getScrollParent(document.querySelector(element));
      this.$scrollTo(element, 300, {
        container,
        easing: 'ease-in-out',
        offset: this.panelScrollConfig.offset || 0
      });
    },
    handlePanelClick(name) {
      let expandedPanels = this.model.slice(0);
      const index = expandedPanels.indexOf(name);
      if (this.accordion) {
        if (index > -1) {
          expandedPanels = [];
        } else {
          this.scrollPanelIntoView(name);
          expandedPanels = [].concat(name);
        }
        this.model = expandedPanels;
        return;
      }
      if (index > -1) {
        expandedPanels.splice(index, 1);
      } else {
        this.scrollPanelIntoView(name);
        expandedPanels.push(name);
      }
      this.model = expandedPanels;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-collapse.vue2.js.map
